const ChatTextarea = {
  install: (Vue) => {
    Vue.component('ChatTextarea', () => {
      return import('./components/index.vue');
    });
  },
};

export default ChatTextarea;
